var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doc-flex"},[_c('h5',{staticClass:"title doc-description"},[_vm._v(_vm._s(_vm.description))]),_vm._v(" "),_c('h6',{staticClass:"title doc-party"},[_c('em',[_vm._v(_vm._s(_vm.party))])]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("Filed: "+_vm._s(_vm.date))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1274da11","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/Documents.vue
// module id = 53
// module chunks = 0